import Http from "../helpers/Http";

class ResourceDataService {
  
  getFiles(type){
    return Http.get(`users/files?type=${type}`)
  }

}

export default new ResourceDataService();